module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/address/secondary_address.js
 ** module id = 836
 ** module chunks = 0
 **/